import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const baseCls = "w-full bg-[#1C1C1C] border border-[#C9A24B]/20 rounded-xl px-4 py-3.5 pr-12 focus:outline-none focus:border-[#C9A24B] transition-colors";

export const PasswordInput = ({ label, className, toggleTestId = "password-toggle", ...props }) => {
  const [show, setShow] = useState(false);
  const field = (
    <div className="relative">
      <input {...props} type={show ? "text" : "password"} className={className || baseCls} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={toggleTestId}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-[#F5EFE3]/40 hover:text-[#C9A24B] transition-colors"
      >
        {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
  if (!label) return field;
  return (
    <div>
      <label className="block text-xs uppercase tracking-widest text-[#F5EFE3]/50 mb-2">{label}</label>
      {field}
    </div>
  );
};
